<template>
	<div>
		<Form ref="formInline" :model="formInline" inline style="text-align: left;margin-top: 1%;">
			<FormItem prop="trackName" label="充电站:" :label-width="60">
				<Select placeholder="站点列表" style="width: 120px;" v-model="formInline.StationId">
					<Option :value=0>全部</Option>
					<Option v-bind:key="item.StationId" v-for="(item) in StationList" :value="item.StationId">
						{{item.StationName}}
					</Option>
				</Select>
			</FormItem>
			<FormItem prop="trackName">
				<Input type="text" style="width: 180px;" v-model="formInline.OrderNo" placeholder="订单单号">
				<span slot="prepend">订单单号</span>
				</Input>
			</FormItem>
			<!-- <FormItem label="开始时间" :label-width='70'>
				<DatePicker style="width: 110px;" type="date" format="yyyy-MM-dd" placeholder="Select date"
					v-model="formInline.TimeBegin"></DatePicker>
			</FormItem> -->
			<!-- <FormItem label="结束时间" :label-width='70'>
				<DatePicker style="width: 110px;" type="date" format="yyyy-MM-dd" placeholder="Select date"
					v-model="formInline.TimeEnd"></DatePicker>
			</FormItem> -->
			<FormItem label="选择时间" :label-width='70'>
				<DatePicker style="width: 210px;" type="daterange" format="yyyy-MM-dd" placeholder="Select date"
					v-model="formInline.TimeRange" @on-change="handleChange"></DatePicker>
			</FormItem>
			<!-- <FormItem label="会员名称" :label-width='70'>
				<Input type="text" v-model="formInline.MemberName" placeholder="会员名称">
				<span slot="prepend">会员名称</span>
				</Input>
			</FormItem> -->
			<FormItem label="设备编号" :label-width='70'>
				<Input type="text" style="width: 150px;" v-model="formInline.EquipmentNo" placeholder="设备编号">
				<span slot="prepend">设备编号</span>
				</Input>
			</FormItem>
			<FormItem>
				<Button type="primary" @click="handleSubmit('formInline')" v-if="hasWidgets('search')">查询</Button>
			</FormItem>
			<FormItem>
				<Button type="primary" @click="exportFile" v-if="hasWidgets('export')">导出文件</Button>
			</FormItem>
		</Form>
		<Table :row-class-name="rowClassName" :columns="columns1" :data="data1" :height="tableHeight" ref="ChargingOrder">
		</Table>
		<MyPage ref="sonPage" :param="pageParam" :url="getOfflineRecordUrl" @listData='getDeviceData'></MyPage>
		<echartModal ref="echartModal" curvesName="OfflineCardRecord"></echartModal>
	</div>
</template>

<script>
	import dateFormat from '../../../../public/js/comm.js'
	import echartModal from '../../public/CurvesTemplate/ChargingOrderEchart.vue'
	import Qs from 'qs'
	import {
		mapState,
		mapGetters,
		mapActions
	} from 'vuex'
	import webapi from '../../../webapi.js'
	export default {
		components: {
			echartModal
		},
		data() {
			return {
				getOfflineRecordUrl: webapi.base_api_url + '/Order/GetOfflineRecord',
				loadingStatus: false,
				//model表单
				params: "", //table 传参
				//选择展示的充电站
				SelectStation: "有家充电站",
				tableHeight: "650",
				modal: {
					Title: "设备信息添加",
					type: "addDevice"
				},
				BreadcrumbList: ['离线卡记录', '>>', '离线卡记录'],
				formInline: {
					StationId: 0,
					OrderNo: '',
					TimeBegin: dateFormat.formatDate(new Date('2024-01-01'), 'yyyy-MM-dd'),
					TimeEnd: dateFormat.formatDate(new Date('2024-01-02'), 'yyyy-MM-dd'),
					TimeRange: [new Date('2024-01-01'), new Date('2024-01-02')],
					MemberName: '',
					EquipmentNo: ''
				},
				//table标题数据
				columns1: [{
						title: '订单单号',
						key: 'OrderNo',
						// fixed: 'left',
						width: 265
					},
					{
						title: '充电开始时间',
						key: 'StartTime',
						width: 160
					},
					{
						title: '充电结束时间',
						key: 'EndTime',
						width: 160
					},
					{
						title: '充电卡号',
						key: 'CardNo',
						width: 266
					},
					{
						title: '充电电量(度)',
						key: 'ChargeKwh',
						width: 110
					},
					{
						title: '充电电费(元)',
						key: 'ElecCost',
						width: 110
					}, {
						title: '充电服务费(元)',
						key: 'ServiceCost',
						width: 110
					},
					{
						title: '充电总费用(元)',
						key: 'ChargeCost',
						width: 110
					},
					{
						title: '充电时长',
						key: 'ChargeDuration',
						width: 165,
						render: (h, params) => {
							return h('div', params.row.ChargeDurationDesc);
						}
					},
					{
						title: '起始SOC(%)',
						key: 'BeginSoc',
						width: 110
					},
					{
						title: '结束SOC(%)',
						key: 'EndSoc',
						width: 110
					},
					// {
					// 	title: '充电前电表示值',
					// 	key: 'MeterBeginReading',
					// 	width: 120
					// },
					// {
					// 	title: '充电后电表示值',
					// 	key: 'MeterEndReading',
					// 	width: 120
					// },
					{
						title: '停止原因',
						key: 'TerminateReason',
						width: 130
					},
					// {
					// 	title: '设备编号',
					// 	key: 'EquipmentNo',
					// 	width: 110
					// }, 
					// {
					// 	title: '枪编号',
					// 	key: 'ConnectorNo',
					// 	width: 110
					// }, 
					{
						title: '站点名称',
						key: 'StationName',
						width: 110,
					},
					{
						title: '操作',
						key: 'action',
						align: 'center',
						width: 100,
						render: (h, params) => {
							return h('div', [
								this.hasWidgets('chargeCurves') ? h('Button', {
									props: {
										type: 'primary',
										size: 'small'
									},
									style: {
										marginRight: '5px'
									},
									on: {
										click: () => {
											this.show("view", params.row.OrderNo)
										}
									}
								}, '充电曲线') : h(),
							]);
						}
					}
				],
				data1: [],
			};
		},
		created() {
			const _this = this;
			// _this.tableHeight = window.innerHeight - 220;
			this.getTableHeight();
			window.addEventListener('resize', this.getTableHeight)
		},
		destroyed() {
			window.removeEventListener("resize", this.getTableHeight);
		},
		mounted() {
			this.handleSubmit();
		},
		computed: {
			pageParam: function() {
				const _this = this;
				// const param = {
				// 	StationId: _this.formInline.StationId,
				// 	OrderNo: _this.formInline.OrderNo,
				// 	TimeBegin: _this.formInline.TimeBegin == '' ? '' : dateFormat.formatDate(new Date(_this
				// 		.formInline.TimeBegin), 'yyyy-MM-dd'),
				// 	TimeEnd: _this.formInline.TimeEnd == '' ? '' : dateFormat.formatDate(new Date(_this.formInline
				// 		.TimeEnd), 'yyyy-MM-dd'),
				// 	MemberName: '',
				// 	EquipmentNo: ''
				// }
				let param = _this.formInline;
				param.TimeBegin = _this.formInline.TimeBegin == '' ? '' : dateFormat.formatDate(new Date(_this
					.formInline.TimeBegin), 'yyyy-MM-dd');
				param.TimeEnd = _this.formInline.TimeEnd == '' ? '' : dateFormat.formatDate(new Date(_this.formInline
					.TimeEnd), 'yyyy-MM-dd');
				return param
			},
			//直接选属性
			...mapState({
				StationList: 'Stations'
			})
		},
		watch: {},
		methods: {
			hasWidgets: function(widgetName) {
				return this.$route.meta.widgets.find(w => w.Name == widgetName);
			},
			handleChange(date, type) {
				console.log("日期改变：", date, type);
				this.formInline.TimeBegin = date[0];
				this.formInline.TimeEnd = date[1];
			},
			exportFile: function() {
				this.$refs.ChargingOrder.exportCsv({
					filename: '离线卡记录',
					data: this.data1.map(k => {
						k.OrderNo = "\t" + k.OrderNo;
						// k.OrderTime = '\t' + (k.OrderTime || '');
						k.StartTime = '\t' + (k.StartTime || '');
						k.EndTime = '\t' + (k.EndTime || '');
						// k.RefundTime = '\t' + (k.RefundTime || '');
						return k;
					})
				})
			},
			rowClassName: function(row, index) {
				if (index % 2 == 0) {
					return 'demo-table-info-row';
				} else if (index % 2 == 1) {
					return 'demo-table-error-row';
				}
				return '';
			},
			//操作
			show: function(type, params) {
				const _this = this
				switch (type) {
					case "view":
						_this.$refs.echartModal.show(type, params)
						break;
					default:
						break;
				}
			},
			//Page组件回调
			getDeviceData: function(data) {
				console.log(data)
				this.data1 = data.Data.List
			},
			handleSubmit: function() {
				if (!this.hasWidgets('search')) return;
				this.$refs.sonPage.getList();
			},
			getTableHeight: function() {
				this.tableHeight = window.innerHeight - 220 - (window.innerWidth < 1278 ? 60 : 0);
			}
		},
	}
</script>

<style>
	/* 	#tree{
		width: 1200px;
		height: 600px;
		margin-top: 7%;
		border: 2px solid red;
	} */

	.ivu-tag-dot {
		border: 0px solid #e8eaec !important;
	}
</style>
